import KeyValueMap from './_key-value-map.js'
import SymbolOverrides from './_symbol-overrides.js'
import CurrencyLocaleOverrides from './_currency-locale-overrides.js'

export default {
  name: 'Currencies',
  values: {
    defaultCurrencyCode: undefined,
    defaultOptions: {
      configSet: KeyValueMap,
      configValues: {},
    },
    optionsByCurrency: {
      configSet: KeyValueMap,
      configValues: {},
    },
    symbolOverrides: {
      configSet: SymbolOverrides,
      configValues: {},
    },
    currencyLocaleOverrides: {
      configSet: CurrencyLocaleOverrides,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
